import React, { useRef, useState } from "react"
import LogoBar from "components/views/app/nav/LogoBar"
import "css/nav.scss"
import NavMenu from "./NavMenu"
import { MobileTalkToCarrot } from "./MobileTalkToCarrot"
import { Large, Medium, Small } from "../../atoms/Responsive"
import { useWindowEvent } from "utils/hooks/useWindowEvent"
import { useDidMount } from "utils/Hooks"
import { Spacer } from "components/views/atoms/Atoms"
import { useCurrentUser } from "../../../context/user/UserContext"

const Nav = () => {
  const [collapsed, setCollapsed] = useState(true)
  const collapseMenu = () => setCollapsed(true)
  const openMenu = () => setCollapsed(false)
  const navRef = useRef<HTMLElement>(null)
  const { isInAppLockdown } = useCurrentUser()

  const calculateNavPosition = () => {
    requestAnimationFrame(() => {
      const navElement = navRef.current
      if (!navElement) return

      const windowHeight = window.innerHeight
      const scrollPosition = window.pageYOffset
      const navElementHeight = navElement.scrollHeight

      const top = Math.min(scrollPosition, Math.max(navElementHeight - windowHeight, 0))
      navElement.style.top = `-${top}px`
    })
  }

  useDidMount(calculateNavPosition)
  useWindowEvent("scroll", calculateNavPosition)
  useWindowEvent("resize", calculateNavPosition)

  return (
    <>
      <Large>
        <Spacer width={16} />
      </Large>
      <Medium>
        <Spacer width={12.5} />
      </Medium>
      <nav ref={navRef} className="flex-none w5-l w200px-m bg-pampas fixed-ns bottom-0 top-0">
        <LogoBar onClick={openMenu} collapsed={collapsed} />
        <NavMenu collapsed={collapsed} collapseMenu={collapseMenu} appLockedDown={isInAppLockdown} />
        {isInAppLockdown ? null : (
          <Small>
            <MobileTalkToCarrot />
          </Small>
        )}
      </nav>
    </>
  )
}

export { Nav }
